export default __webpack_public_path__ + "static/joko-app-screenshot-home-5-fr@2x-2d87648d62115240fef2f67946dc208f.webp";